export const iconFontAwesomeHandsHandPointRight = (
	<i className="fa-solid fa-hand-point-right"></i>
);
